export default __webpack_public_path__ + "static/media/card-elevation.3abf93d1.svg";